import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

import VueScrollmagic from 'vue-scrollmagic';
Vue.use(VueScrollmagic);

import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox);

import VScrollToTop from 'v-scroll-to-top'
Vue.use(VScrollToTop);

import vmodal from 'vue-js-modal';
Vue.use(vmodal);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import VueRellax from 'vue-rellax'
Vue.use(VueRellax);

import device from "vue-device-detector"
Vue.use(device);

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas);
library.add(fab);
Vue.component('fa', FontAwesomeIcon);

import AOS from 'aos'
import 'aos/dist/aos.css'

import 'bootstrap/dist/css/bootstrap.css';
import './styles/fonts.css'
import './styles/global.scss';

window.$ = window.jQuery = require('jquery');

import 'bootstrap/dist/js/bootstrap';

import { loadImage } from '@/modules/load-image';

let loader;

router.beforeEach((to, from, next) => {
    new Promise((resolve, reject) => {
        loader = Vue.$loading.show({
            backgroundColor: '#000',
            color: '#8e7355',
            opacity: 1,
        });
        resolve();
    }).finally(() => {
        next();
    });
});
router.afterEach(() => {
    loader.hide()
});

Promise.all([
    loadImage('/assets/images/valhallaverse.webp'),
    loadImage('/assets/images/frame-home.webp'),
    loadImage('/assets/images/home-extention.webp'),
    loadImage('/assets/images/frame-road.webp'),
    loadImage('/assets/images/frame-inside.webp'),
    loadImage('/assets/images/frame-big.webp'),
    loadImage('/assets/images/frame-big-up.webp'),
]).then(() => {
    new Vue({
        router,
        store,
        render: (h) => h(App),
        mounted() {
            AOS.init()
        },
    }).$mount('#app');
});
